import { render, staticRenderFns } from "./duo_agentic_chat_view.vue?vue&type=template&id=4cb21c6e"
import script from "./duo_agentic_chat_view.vue?vue&type=script&lang=js"
export * from "./duo_agentic_chat_view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports